import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/he';
import store from './store/configureStore';
import './index.css';
import App from './components/App/App.js';

window.onerror = (msg, src, line, col, err) => {
  document.body.style.cssText = 'background:red;color:white;font-size:20px;padding:20px;white-space:pre-wrap;position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;overflow:auto;';
  document.body.innerHTML = 'ERROR:\n' + msg + '\n\n' + src + ':' + line + '\n\n' + (err && err.stack ? err.stack : '');
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="he">
      <App />
    </LocalizationProvider>
  </Provider>
);
